import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rr-ai-control-result',
  standalone: false,
  templateUrl: './ai-control-result.component.html',
  styleUrl: './ai-control-result.component.scss'
})
export class AiControlResultComponent {
  @Input() content: string = "";
  @Output() edit: EventEmitter<any> = new EventEmitter<any>();
}
